import React, { Component } from 'react';

export class FooterOne extends Component {
    componentDidMount() {
        // Create script element
        const script = document.createElement('script');
        script.type = 'text/javascript';
        script.src = 'https://d3mkw6s8thqya7.cloudfront.net/integration-plugin.js';
        script.id = 'aisensy-wa-widget';
        script.setAttribute('widget-id', 'aaab0i');
        script.async = true;
        
        // Append to document body
        document.body.appendChild(script);
        
        // Clean up function
        this.scriptElement = script;
    }
    
    componentWillUnmount() {
        // Remove script when component unmounts
        if (this.scriptElement) {
            document.body.removeChild(this.scriptElement);
        }
    }
    
    render() {
        let FooterData = this.props.FooterData;
        return (
            <footer className="footer-wrapper footer-one">
                <div className="footer-widgets-wrapper section-bg text-white vFooterBg">
                    {/* Existing footer content */}
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-4 col-lg-4 col-12">
                                <div className="single-footer-widget">
                                    <div className="widegts-content">
                                        <div className='vLogoFooter'>
                                            <img src={require("../../assets/img/whatsinaname/Header-logo.png")} alt="" />
                                            <p>
                                                Sleep Therapeutics is a revolutionary approach to treating sleep disorders. Carving out a niche in the Telugu states, Sleep Therapeutics has taken a bold stand on the need for deep and quality sleep in our society.
                                            </p>
                                            <p>
                                                We take our citizen's sleep issues seriously for their and the nation's well-being.
                                            </p>
                                            <p className='socialMedia'>
                                                <a href="https://www.facebook.com/profile.php?id=100089385787735" target='_blank'><i className="fab fa-facebook"></i></a>
                                                <a href="https://www.instagram.com/sleeptherapeuticsindia/" target='_blank'><i className='fab fa-instagram'></i></a>
                                                <a href='https://www.linkedin.com/company/sleeptherapeuticsindia' target='_blank'><i className='fab fa-linkedin'></i></a>
                                                <a href='https://twitter.com/sleeptherap' target='_blank'><i className='fab fa-twitter'></i></a>
                                                <a href='https://www.youtube.com/@sleeptherapeuticsindia' target='_blank'><i className="fab fa-youtube"></i></a>
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {
                                FooterData.singleWidget.map((widget, index) => {
                                    return (
                                        <div className={`col-sm-6 col-lg-2 col-12`} key={index}>
                                            <div className="single-footer-widget">
                                                <div className="f-widget-title">
                                                    <h2 className='vBlackColr' key={widget.id}>{widget.title}</h2>
                                                </div>
                                                <div className="widegts-content">
                                                    {
                                                        widget.menuItems.map(item => {
                                                            return (
                                                                <a href={item.url} key={item.id}>{item.title}</a>
                                                            )
                                                        })
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }

                            <div className="col-sm-8 col-lg-6 col-12">
                                <div className="single-footer-widget">
                                    <div className="f-widget-title">
                                        <h2 className='vBlackColr'>Our Branches</h2>
                                    </div>
                                    <div className='footerAddress'>
                                        <div className="widegts-content">
                                            <h5 className='branchNames'>Film Nagar</h5>
                                            <p>Plot no.11, Filmnagar, 8-2-293/82,
                                                <br /> Road No. 82, J-III, Jubilee Hills,<br />Hyderabad - 500 033, Telangana</p>
                                            <li>888 666 8162
                                                <p>(Monday - Saturday 10am-8pm)</p>
                                                <p>(Sunday - 10am -2pm)</p>
                                            </li>
                                            <li>info@sleeptherapeutics.in</li>
                                        </div>
                                        <div className="widegts-content">
                                            <h5 className='branchNames'>Kukatpally</h5>
                                            <p>Metro Pillar No.730, Plot no.35/2,
                                                <br /> beside Prathima Hospital,<br />Jawaharlal Nehru Technological University, <br />Bhagya Nagar Colony, Kukatpally,<br />Hyderabad, Telangana 500072</p>
                                            <li>888 666 8164
                                                <p>(Monday - Saturday 10am-8pm)</p>
                                                <p>(Sunday - 10am -2pm)</p>
                                            </li>
                                            <li>info@sleeptherapeutics.in</li>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer-copyright-wrapper text-center">
                    <div className='container'>
                        <div className='row'>
                            <div className='col-12'>
                                <div className='vFooterBottom'>
                                    <p>&copy; {FooterData.copyright}</p>
                                    <p>Website Designed & Developed by <a href="https://www.whatsinaname.in/" target='_blank'>What's In a Name</a></p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
        )
    }
}

export default FooterOne